<form [formGroup]="form" class="transparent">
  <div class="row">
    @if (!hideTypeField) {
      <div class="col-4">
        <mat-form-field>
          <mat-label>Current address</mat-label>
          <mat-select formControlName="type">
            <mat-option [value]="addressTypes.STREET">Street</mat-option>
            <mat-option [value]="addressTypes.POSTAL">Postal</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    }

    @if (!hideCountryField) {
      <div class="col-4">
        <app-country-autocomplete formControlName="country" groupBy="category"></app-country-autocomplete>
      </div>
    }

    <div [class]="hideTypeField && hideCountryField ? 'col-12' : 'col-8'">
      <!-- corelogic autocomplete -->
      <mat-form-field [hideRequiredMarker]="hideRequiredMarker">
        <mat-label>{{ label }}</mat-label>

        <input matInput
               [matAutocomplete]="autocomplete"
               [errorStateMatcher]="errorStateMatcher"
               formControlName="searchQuery"
               [placeholder]="placeholder"
               (blur)="onTouched()"/>

        <div matSuffix>
          <ng-container [appPreloader]="[endpoints.PROPERTIES_SUGGESTIONS_GET, endpoints.CORELOGIC_TOKEN_GET]"
                        [preloaderType]="preloaderTypes.ICON"
                        [preloaderSize]="20">
          </ng-container>
        </div>

        <mat-autocomplete #autocomplete="matAutocomplete"
                          (optionSelected)="form.onSelectSuggestion($event.option.value)"
                          [displayWith]="displaySuggestionFn">
          @if ((suggestions$ | async); as suggestions) {
            @for (suggestion of suggestions; track suggestion) {
              <mat-option [value]="suggestion">
                {{ suggestion.suggestion }}
              </mat-option>
            }
            <mat-option>
              Add manually
            </mat-option>
          }
        </mat-autocomplete>

        <mat-error>
          @if (form.get('searchQuery').invalid) {
            <app-validation-error
              [errors]="form.get('searchQuery').errors">
            </app-validation-error>
          }
          @if (form.get('corelogicRefId').invalid && !form.get('searchQuery').invalid) {
            <app-validation-error
              [errors]="form.get('corelogicRefId').errors">
            </app-validation-error>
          }
          @if (form.get('googlePlaceId').invalid && !form.get('searchQuery').invalid) {
            <app-validation-error
              [errors]="form.get('googlePlaceId').errors">
            </app-validation-error>
          }
          @if (form.hasError('address')) {
            <div>{{ form.errors?.address }}</div>
          }
        </mat-error>
      </mat-form-field>
    </div>
  </div>

  @if (form.isManual) {
    <app-address-manual [form]="form"></app-address-manual>
  }
</form>
